import { render } from "./CompliancesIcon.vue?vue&type=template&id=b01dfe56"
import script from "./CompliancesIcon.vue?vue&type=script&lang=js"
export * from "./CompliancesIcon.vue?vue&type=script&lang=js"

import exportComponent from "/Users/denis/Documents/Работа/bitbucket/mifab/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__